import { render, staticRenderFns } from "./WideCol.vue?vue&type=template&id=1708d071&scoped=true&"
import script from "./WideCol.vue?vue&type=script&lang=js&"
export * from "./WideCol.vue?vue&type=script&lang=js&"
import style0 from "./WideCol.vue?vue&type=style&index=0&id=1708d071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1708d071",
  null
  
)

export default component.exports